export class ThresholdData {
  constructor(
    public readonly workshopId: string,
    public readonly thresholdCapacity: string | null,
    public readonly modifiedAt: string,
    public readonly modifiedBy: string
  ) {}
}
